function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99084 1.33334C4.93084 1.33334 0.833336 5.44001 0.833336 10.5C0.833336 15.56 4.93084 19.6667 9.99084 19.6667C15.06 19.6667 19.1667 15.56 19.1667 10.5C19.1667 5.44001 15.06 1.33334 9.99084 1.33334ZM10 17.8333C5.94834 17.8333 2.66667 14.5517 2.66667 10.5C2.66667 6.44834 5.94834 3.16668 10 3.16668C14.0517 3.16668 17.3333 6.44834 17.3333 10.5C17.3333 14.5517 14.0517 17.8333 10 17.8333ZM10.4583 5.91668H9.08334V11.4167L13.8958 14.3042L14.5833 13.1767L10.4583 10.7292V5.91668Z",
  fill: "#373737"
});

function SvgTimeLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLine);
export default __webpack_public_path__ + "static/media/time-line.4932c154.svg";
export { ForwardRef as ReactComponent };